import classNames from 'classnames'

import type { LinkType } from 'types'
import { Props as BaseProps } from './CTABase'

import Button from 'content-components/_Primatives/Button'
import CTABase from './CTABase'

import style from './style.scss'

export type Props = BaseProps & {
  className?: string
  link?: LinkType
  links?: LinkType[]
  buttonColor?: 'red' | 'blue'
}

function CallToAction(props: Props) {
  const { className, buttonColor, ...base } = props

  let links: LinkType[] = []

  if (props.links) {
    links = props.links
  } else if (props.link) {
    links = [props.link]
  }

  return (
    <div className={classNames(style.wrapper, className)}>
      <CTABase {...base} />
      <div className={style.buttons}>
        {links.map((link) => (
          <Button
            key={link.text}
            className={style.button}
            target={link.target}
            url={link.url}
            variant={buttonColor === 'red' ? 'primary' : 'primaryBlue'}
          >
            {link.text}
          </Button>
        ))}
      </div>
    </div>
  )
}

export default CallToAction
